var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29724 0.579163H70.82V70.1338H1.29724V0.579163Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82095 2.06262H69.3301V68.5961H2.82095V2.06262Z",
    fill: "#FCC500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83008 35.3294C3.83008 28.3793 18.2683 22.7434 36.079 22.7434C53.8897 22.7434 68.3279 28.3725 68.3279 35.3294C68.3279 42.2794 53.8897 47.9153 36.079 47.9153C18.2683 47.9153 3.83008 42.2862 3.83008 35.3294Z",
    fill: "#00638D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83008 35.3294C3.83008 28.3793 18.2683 22.7434 36.079 22.7434C53.8897 22.7434 68.3279 28.3725 68.3279 35.3294C68.3279 42.2794 53.8897 47.9153 36.079 47.9153C18.2683 47.9153 3.83008 42.2862 3.83008 35.3294Z",
    stroke: "#00638D",
    strokeWidth: 0.0203,
    strokeMiterlimit: 3.86
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6474 41.4462L18.9996 28.9484H24.2751V36.2981H24.309L27.8982 28.9484H33.2618L29.9163 41.4462H26.4287L28.5754 33.4327H28.5416L24.2751 41.4462H21.485V33.4327H21.4241L19.2841 41.4462H15.6474Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2099 41.6968L34.6839 39.9153H38.5305L38.0564 41.6968H34.2099Z",
    fill: "#E53328"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8126 39.4208L36.7629 32.1592H33.2617L34.1218 28.9484H44.9708L44.1107 32.1592H40.6095L38.6659 39.4208H34.8126Z",
    fill: "#FCC500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4786 41.4462L45.824 28.9484H49.6097L51.3095 35.6342H51.3433L53.1379 28.9484H56.6324L53.2869 41.4462H49.6909L47.8354 34.6181H47.8015L45.9731 41.4462H42.4786Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtn);
export default __webpack_public_path__ + "static/media/MTN.67cf9dc364eece5f1fff871179be69fd.svg";
export { ForwardRef as ReactComponent };